import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Modal from '../Modal';
import { usePreferences } from '../../context/PreferencesContext';
import BottomBar from './footer';

const Footer = () => {
  const { preferences, setPreferences } = usePreferences();

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [cookiePreferences, setCookiePreferences] = useState<Record<string, unknown>>(preferences);
  const [cookiePreferencesVisible, setCookiePreferencesVisible] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setCookiePreferences((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setPreferences(cookiePreferences);
    setModalIsOpen(false);
  };

  useEffect(() => {
    setCookiePreferencesVisible(preferences['analytical'] === undefined);
  }, [preferences['analytical']]);

  return (
    <>
      <footer className="fixed bottom-0 left-0 right-0 flex flex-col-reverse md:flex-row justify-between items-end w-full">
        <div className={`cookie-banner bg-main-light md:mb-12 md:p-12 p-8 ${cookiePreferencesVisible ? 'block' : 'hidden'}`}>
          <h2>Cookies</h2>
          <p className="my-4">
            Deze website maakt gebruik van cookies om de gebruikerservaring te verbeteren en het gebruik van de website te analyseren.
          </p>
          <div className="cookie-actions w-full flex justify-between items-center space-x-4">
            <Link to="https://thuisleefgids.nl/cookiebeleid/" className="w-1/2" target="_blank" rel="noopener noreferrer">
              <strong className="underline text-main text-lg">Meer informatie</strong>
            </Link>
            <button
              className="deny-button btn btn-primary-outline bg-white w-1/2 text-lg"
              onClick={() => {
                const updated = { ...cookiePreferences, analytical: false };
                setPreferences(updated);
                setCookiePreferences(updated);
                setCookiePreferencesVisible(false);
              }}
            >
              Weigeren
            </button>
            <button
              className="accept-button btn btn-primary-outline bg-white w-full text-lg"
              onClick={() => {
                const updated = { ...cookiePreferences, analytical: true };
                setPreferences(updated);
                setCookiePreferences(updated);
                setCookiePreferencesVisible(false);
              }}
            >
              Akkoord
            </button>
          </div>
        </div>
      </footer>
      <BottomBar onModalOpen={() => setModalIsOpen(true)} />
      <Modal show={modalIsOpen} handleClose={() => setModalIsOpen(!modalIsOpen)}>
        <form onSubmit={handleSubmit}>
          <div className="max-w-[600px] p-6 pb-0">
            <h3>Cookie voorkeuren instellen</h3>
            <p>
              Deze website maakt gebruik van cookies om de gebruikerservaring te verbeteren en het gebruik van de website te analyseren.
            </p>
            <b>Voorkeuren aanpassen</b>
            <div className="mt-4">
              <input type="checkbox" id="functional" name="functional" checked disabled className="opacity-50 cursor-not-allowed" />
              <label htmlFor="functional" className="opacity-50 cursor-not-allowed">
                Toestemming voor functionele cookies(altijd actief)
              </label>
            </div>
            <div className="mt-4">
              <input
                type="checkbox"
                id="analytical"
                name="analytical"
                checked={(cookiePreferences['analytical'] as boolean) || false}
                onChange={handleChange}
              />
              <label htmlFor="analytical">Toestemming voor analytische cookies</label>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-2.5 p-6">
            <Link className="btn btn-primary-outline bg-white" to="#" onClick={() => setModalIsOpen(false)}>
              Annuleren
            </Link>
            <button className="btn btn-primary" type="submit">
              Opslaan
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default Footer;
